import AlertModal from "@/components/common/AlertModal.vue";
import RequestAlert from "@/components/common/RequestAlert.vue";
import { asyncModal } from "@/components/ui/modal/utils";

export default function showAlert(
  message,
  { btnText = "ОК", large = false } = {}
) {
  return asyncModal({
    name: "app-alert-modal",
    component: AlertModal,
    closable: false,
    props: {
      message,
      btnText,
      large
    }
  });
}

export const alertMessages = {
  request: "Во время выполнения запроса произошла ошибка."
};

export const requestErrorAlert = showAlert.bind(
  undefined,
  alertMessages.request
);

export function requestAlert(message = alertMessages.request, errors = []) {
  return asyncModal({
    name: "app-alert-modal",
    component: RequestAlert,
    closable: false,
    props: {
      message,
      errors
    }
  });
}
